import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EField, IExtraData } from "./schema.editPropertyInfo.types";

export const getInitialValues = ({ property }: IExtraData): IValues => {
  return {
    [EField.Costs]: property.costs,
    [EField.Price]: property.price,
  };
};
